import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { errorMessage } from '../actions/internal';
import { appNamedRoutes, isValidAuth } from '../routes';
import { MSG_ALREADY_AUTHENTICATED } from '../utils/messages';
import SparklerLogo from '../../assets/images/sparkler-logo.svg';

class DeviseLayout extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    allowAuthenticated: PropTypes.bool,
    children: PropTypes.object,
    cta: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    // action
    errorMessage: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const { allowAuthenticated, auth, children, cta, subTitle, title } = this.props;
    const { authExpires, isAuthenticated, isAuthReset } = auth;

    if (!allowAuthenticated && isValidAuth(isAuthenticated, authExpires)) {
      this.props.errorMessage(MSG_ALREADY_AUTHENTICATED(), 'warning');
      return <Redirect to={{ pathname: appNamedRoutes.root }} />;
    }

    if (isAuthReset) {
      return <Redirect to={{ pathname: appNamedRoutes.login }} />;
    }

    return (
      <DocumentTitle title={title}>
        <div className="cs-bg--sp-black o-login__wrap">
          <form className="row o-login align-middle" onSubmit={this.props.onSubmit}>
            <div className="o-login__input o-login__logo u-margin-bottom--base">
              <img alt='' src={SparklerLogo} />
            </div>
            <div className="o-login__input">
              <h4 className='cs-txt--light text-center'>{subTitle}</h4>
              {children}
              <div className="text-center">
                <button type="submit" className="o-sp-button o-sp-button--primary o-sp-button--login o-sp-button--block u-padding-left--base u-padding-right--base">
                  {cta}
                </button>
              </div>
              <div className="u-margin-top--base">
                <hr className="u-margin-bottom--small" />
                <Link className='cs-txt-link--light' to={{ pathname: appNamedRoutes.login }}>{this.props.t('auth.login')}</Link>
              </div>
            </div>
          </form>
        </div>
      </DocumentTitle>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  }
}

export default connect(mapStateToProps, { errorMessage })(withTranslation()(DeviseLayout));
